var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShareFacebook38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1877F2",
  d: "M19.374 38c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19 8.507 19 19 19"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m22.701 20.465.456-2.977h-2.855v-1.93a1.49 1.49 0 0 1 1.678-1.608h1.3v-2.534c-.76-.123-1.53-.19-2.3-.2a3.634 3.634 0 0 0-3.888 4.005v2.267h-2.621v2.977h2.614v7.194c1.066.166 2.151.166 3.217 0v-7.194z"
})));
export default SvgIconShareFacebook38;